if (!customElements.get('ns-product-catalog')) {
  customElements.define('ns-product-catalog', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.rail = this.querySelector('[data-ns-color-rail]');
      if (this.rail) {
        const previous = this.querySelector('[data-ns-rail-prev]');
        const next = this.querySelector('[data-ns-rail-next]');
        const updateRail = () => {
          this.railFrame = null;
          const remaining = this.rail.scrollWidth - this.rail.clientWidth;
          if (previous) previous.disabled = this.rail.scrollLeft <= 1;
          if (next) next.disabled = this.rail.scrollLeft >= remaining - 1;
        };
        const moveRail = direction => {
          const card = this.rail.querySelector('.ns-cat-card');
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap);
          this.rail.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous?.addEventListener('click', () => moveRail(-1), options);
        next?.addEventListener('click', () => moveRail(1), options);
        this.rail.addEventListener('scroll', () => {
          if (!this.railFrame) this.railFrame = requestAnimationFrame(updateRail);
        }, { ...options, passive: true });
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          moveRail(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.railResize = new ResizeObserver(updateRail);
        this.railResize.observe(this.rail);
        updateRail();
      }
      this.stockDialog = this.querySelector('[data-ns-stock-dialog]');
      this.querySelectorAll('[data-ns-notify]').forEach(button => button.disabled = false);
      this.addEventListener('click', event => {
        const buy = event.target.closest('[data-ns-buy-open]');
        if (buy) {
          this.buyOpener = buy;
          this.buyDialog = this.querySelector(`#${CSS.escape(buy.dataset.nsBuyOpen)}`);
          this.updateChoice(this.buyDialog.querySelector('[data-ns-buy-choice]:checked'));
          this.buyDialog.showModal();
          this.buyDialog.querySelectorAll('[data-ns-pack-picture] img').forEach(image => image.loading = 'eager');
          document.documentElement.classList.add('ns-buy-open');
        }
        if (event.target.closest('[data-ns-buy-close]')) event.target.closest('dialog').close();
        const notify = event.target.closest('[data-ns-notify]');
        if (notify) {
          this.stockOpener = notify;
          const model = notify.dataset.stockTitle;
          this.stockDialog.querySelector('[data-ns-stock-model]').textContent = model;
          const body = this.stockDialog.querySelector('[data-ns-stock-body]');
          if (body) body.value = this.stockDialog.dataset.requestTemplate.replace('__model__', model);
          const product = this.stockDialog.querySelector('[data-ns-stock-product]');
          if (product) product.value = notify.dataset.stockProduct;
          const variant = this.stockDialog.querySelector('[data-ns-stock-variant]');
          if (variant) variant.value = notify.dataset.stockVariant || '';
          this.stockDialog.showModal();
          document.documentElement.classList.add('ns-stock-open');
        }
        if (event.target.closest('[data-ns-stock-close]')) this.stockDialog.close();
      }, options);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-ns-buy-choice]')) this.updateChoice(event.target);
      }, options);
      this.querySelectorAll('[data-ns-buy-dialog]').forEach(dialog => {
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('ns-buy-open');
          if (!this.cartOpening) this.buyOpener?.focus({ preventScroll: true });
          this.cartOpening = false;
        }, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
      });
      this.stockDialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ns-stock-open');
        this.stockOpener?.focus({ preventScroll: true });
      }, options);
      this.addEventListener('submit', event => {
        if (!event.target.matches('.ns-stock-form')) return;
        try { sessionStorage.setItem('ns-stock-response-form', event.target.id); } catch {}
      }, options);
      const stockResult = this.stockDialog.querySelector('[data-ns-stock-result]');
      if (stockResult) {
        let responseForm = '';
        try { responseForm = sessionStorage.getItem('ns-stock-response-form') || ''; } catch {}
        const ownForm = this.stockDialog.querySelector('form');
        if (responseForm ? responseForm === ownForm?.id : stockResult === document.querySelector('[data-ns-stock-result]')) this.stockDialog.showModal();
      }
      customElements.whenDefined('product-form').then(() => {
        if (!this.isConnected) return;
        this.querySelectorAll('[data-ns-buy-open]').forEach(button => button.disabled = false);
        if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'product-form' || !this.buyDialog?.open) return;
          const variant = this.buyDialog.querySelector('[name=id]').value;
          if (String(event.productVariantId) !== variant) return;
          this.cartOpening = true;
          this.buyDialog.close();
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          cart?.setActiveElement(this.buyOpener);
        });
      });
    }
    updateChoice(choice) {
      if (!choice) return;
      const dialog = choice.closest('dialog');
      dialog.querySelector('[name=id]').value = choice.dataset.variant;
      dialog.querySelector('[data-ns-buy-price]').textContent = choice.dataset.price;
      const comparison = dialog.querySelector('[data-ns-buy-comparison]');
      if (comparison) {
        comparison.hidden = !choice.dataset.compare;
        comparison.querySelector('[data-ns-buy-compare-price]').textContent = choice.dataset.compare || '';
        comparison.querySelector('[data-ns-buy-compare-label]').textContent = choice.dataset.compareLabel || '';
        const badge = comparison.querySelector('[data-ns-buy-discount]');
        badge.textContent = choice.dataset.discount || '';
        badge.setAttribute('aria-label', choice.dataset.discountLabel || '');
      }
      const saving = dialog.querySelector('[data-ns-buy-saving]');
      if (saving) {
        saving.hidden = !choice.dataset.saving;
        saving.textContent = choice.dataset.saving || '';
      }
      dialog.querySelector('[data-ns-buy-summary]').textContent = choice.dataset.summary;
      dialog.querySelector('[data-ns-buy-details]').href = `${dialog.querySelector('[data-ns-buy-details]').href.split('?')[0]}?variant=${choice.dataset.variant}`;
      const selectedBags = Number(choice.dataset.bags);
      const pictureCount = dialog.querySelector(`[data-ns-pack-picture="${selectedBags}"]`) ? selectedBags : 1;
      dialog.querySelectorAll('[data-ns-pack-picture]').forEach(picture => {
        picture.hidden = Number(picture.dataset.nsPackPicture) !== pictureCount;
      });
      const productForm = dialog.querySelector('product-form');
      const available = choice.dataset.available === 'true';
      productForm.toggleSubmitButton(!available, available ? this.dataset.addLabel : this.dataset.soldOutLabel);
      productForm.submitButtonText.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      productForm.handleErrorMessage();
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      document.documentElement.classList.remove('ns-buy-open', 'ns-stock-open');
      this.abort?.abort();
      this.unsubscribe?.();
      this.railResize?.disconnect();
      if (this.railFrame) cancelAnimationFrame(this.railFrame);
    }
  });
}
